<adaa-data-table
    titleHeader="international_projects.visits.achievements"
    [isLocalData]="true"
    [localData]="tableData"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.INTP_COUNTRY_ACHIEVEMENTS_CONF_LIST"
    [enableAdd]="!isDisabled()"
    [enableEditAction]="!isDisabled()"
    [enableDeleteAction]="!isDisabled()"
    [enableExport]="false"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="actionClicked($event)"
/>
